import React from "react";
import { Col, Row } from "react-bootstrap";
import * as CONSTANT from "../../constants";
import { REACT_APP_CLOUD_FRONT } from "../../constants";
import styleClasses from "./career.module.scss";
import { useNavigate } from "react-router";
import ReactPlayer from "react-player/file";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
interface TeamIntroProps {
  title?: JSX.Element;
  description?: JSX.Element;
  btnText?: string;
  imgUrl?: string;
  isVideo?: Boolean;
  videoUrl?: string;
  isReversed: boolean;
  borderBottom?: string;
  className?: string;
  sectionClasses?: string;
  btnRoute?: string;
  isInternalRoute?: boolean;
}
const TeamIntro: React.FC<TeamIntroProps> = ({
  title,
  description,
  btnText,
  imgUrl,
  isVideo,
  isReversed,
  borderBottom,
  className,
  sectionClasses,
  btnRoute,
  isInternalRoute,
}) => {
  const history = useNavigate();
  const isItMobile = useCheckMobileScreen();
  return (
    <>
      <div
        className={`container-fluid ${styleClasses.teamIntroWrapper} ${sectionClasses}`}
      >
        <Row className={borderBottom && "border-bottom"}>
          <Col lg="6" md="6" sm="12" xs="12" className={"px-0 order-md-2"}>
            <div className={` ${styleClasses.VideoWrapper} h-100`}>
              {isVideo ? (
                isItMobile ? (
                  <ReactPlayer
                    width="100%"
                    playsinline
                    url={`${CONSTANT.REACT_APP_CLOUD_FRONT}/images/travel-abroad/HighlightReel22.mp4`}
                    controls={false}
                    playing={true}
                    muted={true}
                    loop={true}
                    style={{
                      objectFit: 'cover'
                    }}
                  />
                ) : (
                  <video
                    autoPlay
                    muted
                    loop
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <source src={`${CONSTANT.REACT_APP_CLOUD_FRONT}/images/travel-abroad/HighlightReel22.mp4`} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )
              ) : (
                <img
                  src={`${REACT_APP_CLOUD_FRONT}/${imgUrl}`}
                  alt="img"
                  className="w-100 h-100"
                />
              )}
            </div>
          </Col>
          <Col
            lg="6"
            md="6"
            sm="12"
            xs="12"
            className={`${isReversed ? "order-2" : ""} px-0 ${className}`}
          >
            <div
              className={`d-flex align-items-center justify-content-center flex-column h-100 py-5 ${styleClasses.descriptionContent}`}
            >
              <h2
                className={`${className} clr-green-clr f-s40 f-w4 font-Cls text-capitalize mb-0 f-sm-s20`}
              >
                {title}
              </h2>
              <div className="f-s20 f-w4 clr-dark-grey px-md-5 f-sm-s16 px-2 font-Trade-regular">
                {description}
              </div>
              {isInternalRoute ? (
                <a
                  onClick={() => {
                    history(btnRoute);
                  }}
                  className={`${styleClasses.careerBtns} text-decoration-none color-white f-s20 f-w7 font-Visby-cf text-uppercase btn btn-large f-sm-s14 mt-3 mt-md-5`}
                >
                  {btnText}
                </a>
              ) : (
                <a
                  href={CONSTANT.CAREERS_APPLY_ROUTE_URL}
                  target="blank"
                  className={`${styleClasses.careerBtns} text-decoration-none color-white f-s20 f-w7 font-Visby-cf text-uppercase btn btn-large f-sm-s14 mt-3 mt-md-5`}
                >
                  {btnText}
                </a>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default TeamIntro;
